const host = process.env.REACT_APP_HOST;

export const loginEmail = `${host}/login/send-otp`;
export const verifyOtp = `${host}/login/verify-otp`;
export const refreshTokenApi = `${host}/login/refresh-token`;
export const editAccess = `${host}/users/update/access`;
export const deleteAllAccess = `${host}/users/delete/allAccess`;
export const getUsers = `${host}/endusers`;
export const getUsersWithAccess = `${host}/users_with_access`;
export const updateUser = `${host}/users/update`;
export const createUser = `${host}/create_user`;
export const DeleteUser = `${host}/users/delete`;
export const deleteUserAccess = `${host}/users/delete/access`;
export const projectsApi = `${host}/projects`;
export const recentActivityApi = `${host}/activity/recent`;
export const activityLogsApi = `${host}/activity/logs`;
export const emailTemplatesApi = `${host}/email-templates`;
export const organizationHierarchyApi = `${host}/api/organization/hierarchy`;
export const organizationUserHierarchyApi = `${host}/api/organization/users`;
export const organizationReassignApi = `${host}/api/organization/reassign`;
export const organizationValidateMoveApi = `${host}/api/organization/validate-move`;
// export const fetchDatabase = `${host}/connect/database`;

// Documents
export const employeeDocumentsApi = (empId) => `${host}/employees/${empId}/documents`;
export const employeeDocumentDownloadApi = (empId, docId) => `${host}/employees/${empId}/documents/${docId}/download`;
export const employeeDocumentDeleteApi = (empId, docId) => `${host}/employees/${empId}/documents/${docId}`;
export const employeeFullProfileApi = (empId) => `${host}/employees/${empId}/full`;
export const employeeSearchApi = `${host}/employees/search`;

// Attendance
export const attendanceCheckinApi = `${host}/attendance/checkin`;
export const attendanceCheckoutApi = `${host}/attendance/checkout`;
export const attendanceTodayApi = `${host}/attendance/today`;
export const attendanceMyApi = `${host}/attendance/my`;
export const attendanceAdminDailyApi = `${host}/attendance/admin/daily`;
export const attendanceAdminSummaryApi = `${host}/attendance/admin/summary`;
export const attendanceAdminEmployeeApi = (empId) => `${host}/attendance/admin/employee/${empId}`;
